/* eslint-disable no-unused-vars*/
/* eslint-disable new-cap*/
/* eslint-disable react/prop-types*/
import React, { Fragment } from 'react';
import { UploadOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Modal, Row, Upload } from 'antd';
// import { get } from 'lodash';
import Color from 'constants/color';
import { ButtonEditOutline, ButtonPrimary } from 'common/Button/Button.styles';
import { messageRequireIcon } from 'common/messageError/message.common';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { getCookie } from 'helper/cookie';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { VITE_REACT_PATH_IMAGE } from 'src/private/config';
import { getBannerOwnerGroupUserById, postCreateBannerOwner } from 'api/bannerOwner';
// import Logo from 'public/assets/image/logo/logoCP.png';

const BannerOwnerComponents = () => {
   const [form] = Form.useForm();
   const navigate = useNavigate();
   const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));
   const token = getCookie('access_tokenltl');
   const [previewOpen, setPreviewOpen] = useState(false);
   const [previewImage, setPreviewImage] = useState('');
   const [previewTitle, setPreviewTitle] = useState('');
   const [showImage, setShowImage] = useState('');
   const [fileList, setFileList] = useState([]);
   const dataUser = getCookie('dataUser');
   const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
   const [sendData, setSendData] = useState(false)
   const [dataBanner, setDataBanner] = useState<any>({
      id: null,
      owner_id: null,
      group_user_id: null,
      banner_name: '',
      created_at: '',
      updated_at: ''
    });

   const splitData = dataBanner?.banner_path_local?.split('/');
   const ImageLink: any = splitData
   ? `${VITE_REACT_PATH_IMAGE}/${splitData[4]}/${splitData[5]}`
   : null;

   const handleCancel = () => setPreviewOpen(false);

   const fetchBannerOwner = useCallback(
      async (query?: any) => {
         if (dataBanner?.id !== null) {
            // If dataBanner already has data, skip fetching
            return;
          }
         // setIsLoadingBankTransfer(true);
         const params = {
            group_user_id: Number(parseDataUser?.groupuser_id),
         };
         try {
            const responseData = await getBannerOwnerGroupUserById({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               // console.log('data',data)
               form.setFieldsValue({
                  banner_name : data?.data?.banner_name,
                  // banner_image : data?.data?.banner_image
              });
               setDataBanner(data?.data || {
                  id: null,
                  owner_id: null,
                  group_user_id: null,
                  banner_name: '',
                  created_at: '',
                  updated_at: '',
                  banner_path_local: ''
                });
            } else {
               setDataBanner({
                  id: null,
                  owner_id: null,
                  group_user_id: null,
                  banner_name: '',
                  created_at: '',
                  updated_at: ''
                })
            }
         } catch (error) {
            setDataBanner({
               id: null,
               owner_id: null,
               group_user_id: null,
               banner_name: '',
               created_at: '',
               updated_at: ''
             })
         }
      },
      [token],
   );

   useEffect(() => {
      if (token) {
        fetchBannerOwner();
      }
    }, [token]);


   const dummyRequest = ({ file, onSuccess }: any) => {
      setTimeout(() => {
         onSuccess('ok');
      }, 0);
   };

   const getBase64 = (file: any) =>
      new Promise((resolve, reject) => {
         const reader = new FileReader();
         reader.readAsDataURL(file);
         reader.onload = () => resolve(reader.result);
         reader.onerror = (error) => reject(error);
      });

   const handlePreview = async (file: any) => {
      if (!file.url && !file.preview) {
         file.preview = await getBase64(file.originFileObj);
      }
      setPreviewImage(file.url || (file.preview));
      setPreviewOpen(true);
      setPreviewTitle(file.name);
   };

   const onChange = (info: any) => {
      switch (info.file.status) {
      case 'uploading':
         setFileList(info.file);
         break;
      case 'done':
         setFileList(info.file);
         break;

      default:
         setFileList([]);
      }
   };

   useEffect(() => {
      renderBanner()
   }, [])

   const renderBanner = () => {
      // if(isLoadingCredits){
      //    return (
      //       renderSkeletonTable(4, isLoadingCredits, <></>)
      //    )
      // }
      return (
         <Card 
            title={<p style={{ textAlign: 'center', fontSize: '24px', fontWeight: 600, marginTop: '17px'}}>ชื่อเว็บไซต์ของคุณ</p>}
            style={{ border: `1px solid ${Color.primary}` }}
         >
            <Row gutter={16} justify="space-between">
               <Col span={isMobileView ? 24 :24}>
                  <Form.Item
                     name="banner_name"
                     label="ชื่อเว็บไซต์"
                     rules={[
                        {
                           required: true,
                           message: messageRequireIcon('กรุณากรอกข้อมูล ชื่อเว็บไซต์'),
                        },
                     ]}
                  >
                     <Input type="text" placeholder="ชื่อเว็บไซต์" />
                  </Form.Item>

               </Col>
               <Col span={isMobileView ? 24 : 24}>
               {ImageLink && (
                  <img
                     onClick={() =>
                        {
                           setPreviewOpen(true);
                           setPreviewTitle('');
                           setPreviewImage(ImageLink)
                           setShowImage(ImageLink)
                        }
                     }
                     crossOrigin="anonymous" alt="รูปภาพโลโก้" style={{ width: '80px', height: '80px' }} src={ImageLink || ''} />
                  )}
                  <Form.Item
                     name="banner_image"
                     id="banner_image"
                     label="โลโก้"
                     hasFeedback
                     rules={[
                        {
                           required: false,
                           message: messageRequireIcon('กรุณากรอกข้อมูล กรุณาอัปโหลดรูปภาพ โลโก้'),
                        },
                     ]}
                  >
                     <Upload
                        customRequest={dummyRequest}
                        listType="picture"
                        defaultFileList={fileList}
                        onChange={onChange}
                        onPreview={handlePreview}
                        maxCount={1}
                     >
                        <ButtonEditOutline icon={<UploadOutlined />}>แนบไฟล์โลโก้</ButtonEditOutline>
                     </Upload>
                  </Form.Item>
               </Col>
            </Row>
         </Card>
      )
   }

   const handleSubmit = async (values: any) => {
      setSendData(true)
      Swal.fire({
         title: "ระบบกำลังประมวลผล",
         html: `กรุณารอสักครู่`,
         icon: "info",
         showCloseButton: false, // ไม่แสดงปุ่มปิด
         showConfirmButton: false, // ไม่แสดงปุ่มยืนยัน
         allowOutsideClick: false, // ป้องกันไม่ให้ปิดด้วยการคลิกภายนอก
         didOpen: () => {
            Swal.showLoading(); // แสดงสถานะการโหลด
         }
      });
      const params = {
         banner_name: values?.banner_name,
         banner_image: values?.banner_image,
      }

      const createData = await postCreateBannerOwner({ token, params: params });
      const {status, data} = createData
      if (status === 200) {
         Swal.fire({
            icon: 'success',
            title: 'บันทึกข้อมูลสำเร็จ',
            showConfirmButton: false,
            timer: 5000,
         });
         setSendData(false)
         navigate(`/backoffice/banner_owner`, { replace: false });
      } else {
         Swal.fire({
            icon: 'error',
            title: data?.message,
            timer: 5000,
            showCloseButton: false,
            showCancelButton: false,
            confirmButtonText: 'ปิด',
            buttonsStyling: false,
            customClass: {
                confirmButton: 'swal2-confirm-custom-button',
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
         });
         setSendData(false)
      }
   };

   return (
      <>
         <Form
            layout="vertical"
            autoComplete="off"
            onFinish={handleSubmit}
            form={form}
            initialValues={{
            }}
         >
            <Row gutter={16}>
            <Col span={isMobileView ? 24 : 24}>
                  {renderBanner()}
            </Col>
            </Row>
            <div className='clear-fix mt-4 mb-4' />
            <Row gutter={16}>
               <Col span={12}>
               </Col>
               <Col span={12}>
                  <Button type="primary" htmlType="submit" size='large' className="btn btn-md" style={{ float: 'right' }}>
                     <SaveOutlined /> อัปเดต
                  </Button>
               </Col>
            </Row>
            <div className='clear-fix mt-4 mb-4' />
         </Form>
         <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
            <img crossOrigin="anonymous"  alt="image" style={{ width: '100%' }} src={previewImage ? previewImage : showImage} />
         </Modal>
      </>
   );
};

export default BannerOwnerComponents;